import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import FullUniqueLogo from "../../img/testUniqueLogo.png";
import { useNotify } from "tailwind-notifications-react";
import axios from 'axios';

export const LoginPage = () => {
  const [credentials, setCredentials] = useState({ login: '', password: '' });
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const notify = useNotify();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      navigate('/dashboard');
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    setError('')
    e.preventDefault();

    try {
      const response = await axios.post('https://api.alyonatestsite.store/api/login', {
        login: credentials.login,
        password: credentials.password
      });

        const data = await response.data;
        localStorage.setItem('token', data.token);
        navigate('/dashboard');
        notify({
          title: "Успешный вход в аккаунт",
          type: "success",
        });
      
    } catch (error) {

      console.log(error)
      setError('Неуспешная попытка авторизации');
        notify({
          title: "Не удалось войти",
          message: `Введены некорректные данные. Обратитесь к разработчику для получения помощи`,
          type: "error",
        });
    }
  };

  return (
    <div className='bg-white flex flex-col justify-center items-center h-screen w-full space-y-8'>

<a
href="/">
<img
        src={FullUniqueLogo}
        alt="bg"
        className="w-64 h-16 object-contain"
      />
      </a>

      <h1 className='font-lack text-4xl'>Вход в ПУ</h1>

      <form onSubmit={handleSubmit}
      className='flex flex-col space-y-2'>
        <input
            type="text"
            placeholder="Пользователь"
            value={credentials.login}
            onChange={(e) => setCredentials({ ...credentials, login: e.target.value })}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-400"
          />
        <input
            type="password"
            placeholder="Пароль"
            value={credentials.password}
            onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-400"
          />
        <button className="w-full px-4 py-2 border bg-sky-400 rounded-lg text-white" type="submit">Войти</button>
      </form>
      {error && <p style={{ color: 'red' }}>{error}</p>}
    </div>
  );
};
